const DEFAULT_WIDTH = 512;
const DEFAULT_HEIGHT = 350;
const STACKED_TYPE = 'StackedAreaSpline';
const PERCENTAGE_AREA_SPLINE_TYPE = 'PercentageAreaSpline';

export { DEFAULT_HEIGHT, DEFAULT_WIDTH, PERCENTAGE_AREA_SPLINE_TYPE, STACKED_TYPE };
